import { useEffect, useState } from 'react';

export const useDetectOS = () => {
  const [oS, setOS] = useState<'windows' | 'android' | 'apple'>('windows');

  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor;

    if (/android/i.test(userAgent)) {
      setOS('android');
    } else if (/iPad|iPhone|iPod/.test(userAgent)) {
      setOS('apple');
    } else {
      setOS('windows');
    }
  }, []);

  return oS;
};
